module.exports = __webpack_public_path__ + "img/right_qty_3.6b25f0e4.png";